import { PortalTabsEmptyPage } from '@features/portal-tabs/components/PortalTabsEmptyPage'
import { requireRouteAudience } from '@services/router/routeAccess'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/tabs')({
    component: PortalTabsEmptyPage,
    beforeLoad: requireRouteAudience(['staff']),
    staticData: {
        crumb: {
            label: 'Tabs',
        },
    },
})
